import Axios from '@/Axios'

class WorkflowActionService {
    async addWorkflowAction(data) {
        return await Axios.post(`wms.wms.api.workflow_action.create_workflow_action`, data)
    }
    async getWorkflowAction(data = {}) {
        const queryString = new URLSearchParams(data).toString()
        return await Axios.get(`wms.wms.api.workflow_action.get_worflow_action?${queryString}`)
    }
    async deleteWorkflowAction(action) {
        const transformdAction = action.map((item) => ({ name: item }))
        return await Axios.delete('wms.wms.api.workflow_action.delete_workflow_action', { data: { action: transformdAction } })
    }
}
export default new WorkflowActionService()
